type DynamicFormItem = {
  fields?: {
    fieldName?: { value?: string };
    fieldType?: {
      value?: string;
      fields?: {
        phrase?: { value?: string };
      } | null;
    } | null;
    checked?: { value?: boolean | string | number };
  } | null;
};

type DynamicFormData = {
  fields?: {
    items?: DynamicFormItem[];
  } | null;
};

const normalizeFieldType = (item?: DynamicFormItem) =>
  `${item?.fields?.fieldType?.fields?.phrase?.value || item?.fields?.fieldType?.value || ''}`
    .replace(/[\s_-]+/g, '')
    .toLowerCase();

const isCheckboxItem = (item?: DynamicFormItem) => normalizeFieldType(item) === 'formcheckbox';

const getCheckboxItems = (form?: DynamicFormData | null) =>
  (form?.fields?.items || []).filter(isCheckboxItem);

export const omitDynamicFormCheckboxValues = (
  form: DynamicFormData | null | undefined,
  values: Record<string, any>
) => {
  const checkboxFields = new Set(
    getCheckboxItems(form)
      .map((item) => item.fields?.fieldName?.value?.trim().toLowerCase())
      .filter(Boolean)
  );

  return Object.entries(values).reduce<Record<string, any>>((result, [fieldName, value]) => {
    if (!checkboxFields.has(fieldName.trim().toLowerCase())) {
      result[fieldName] = value;
    }
    return result;
  }, {});
};

export const getDynamicFormCheckboxDefaults = (form?: DynamicFormData | null) =>
  getCheckboxItems(form).reduce<Record<string, { value: boolean }>>((updates, item) => {
    const fieldName = item.fields?.fieldName?.value?.trim();
    if (!fieldName) return updates;

    const checked = item.fields?.checked?.value;
    updates[fieldName] = {
      value: checked === true || checked === 'true' || checked === 1 || checked === '1',
    };
    return updates;
  }, {});
